import React from 'react';
import { siteCopy } from '../../content/siteCopy';

const LessonFlow = () => {
  const { whyChoose, serviceBlocks } = siteCopy;

  return (
    <section className="row_am lesson_flow_section" id="lesson_flow_sec">
      <div className="container">
        <div
          className="section_title"
          data-aos="fade-up"
          data-aos-duration={1500}
        >
          <span className="title_badge">{whyChoose.badge}</span>
          <h2>{whyChoose.title}</h2>
          <p>{whyChoose.intro}</p>
        </div>
        <div className="row lesson_flow_steps">
          {serviceBlocks.map((block, index) => (
            <div
              key={block.badge}
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={index * 75}
            >
              <div className="lesson_flow_card">
                <span className="lesson_flow_badge">{block.badge}</span>
                <h3>{block.title}</h3>
                <p>{block.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LessonFlow;
